module.exports = __webpack_public_path__ + "img/Person Icon - white.6c722152.svg";